// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page {
  height: 100vh;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-page .error-content {
  text-align: center;
}
.error-page .error-content .error-message {
  font-size: 24px;
  color: #666;
  margin: 10px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/error/error.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,kBAAA;AACN;AAAM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAER","sourcesContent":[".error-page {\n    height: 100vh;\n    width: 100%;\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  \n    .error-content {\n      text-align: center;\n      .error-message {\n        font-size: 24px;\n        color: #666;\n        margin: 10px 0 0;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
